import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { LoginCredentials } from './login.reducer';

@Injectable()
export class LoginActions {
    static LOGIN = '[Auth-Login]: Check credentials';
    static LOGIN_CREDENTIAL_SUCCESS = '[Auth-Login]: Credentials successful';
    static LOGIN_AFTER_AGREE = '[Auth-Login] Authenticate after terms agreement';
    static LOGIN_FAIL = '[Auth-Login]: Authentication pending or failed';
    static LOGIN_SUCCESS = '[Auth-Login]: Authentication successful';
    static LOGIN_FORCE_AGREEMENT = '[Auth-Login]: Force agreement';
    static LOGIN_RESET_FORCED_AGREEMENT = '[Auth-Login]: Reset forced agreement';
    static LOGIN_FORCE_PASSWORD_RESET = '[Auth-Login]: Force reset password';
    static LOGIN_RESET = '[Auth-Login]: Reset login state';
    static LOGOUT = '[Auth-Login]: Logout';
    static LOGIN_SUCCESS_AUTH_TOKEN_ONLY = '[Auth-Login]: Authentication successful for auth token';
    static LOGIN_AUTH_TOKEN_ONLY = '[Auth-Login]: Check auth credentials';
    static LOGIN_ID_CARD = '[Auth-Login]: ID card login';
    static LOGIN_MOBILE_ID = '[Auth-Login]: Mobile-ID login';
    static LOGIN_SMART_ID = '[Auth-Login]: Smart-ID login';
    static LOGIN_VIISP = '[Auth-Login]: Viisp login';
    static LOGIN_OIDC_EXCHANGE = '[Auth-Login]: OIDC exchange login';
    static CANCEL_CHALLENGE_POLLING = '[Auth-Login]: Cancel challenge polling';
    static SHOW_TERMS_MODAL = '[Auth-Login]: Show terms modal';
    static HIDE_TERMS_MODAL = '[Auth-Login]: Hide terms modal';

    login(credentials: LoginCredentials): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN,
            payload: credentials
        };
    }

    loginCredentialsSuccess(token: string, ondemandRequest: boolean): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_CREDENTIAL_SUCCESS,
            payload: { token, ondemandRequest }
        };
    }

    loginWithIdCard(token: any, nonce: string): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_ID_CARD,
            payload: { token, nonce }
        };
    }

    loginWithMobileId(verificationCode: string, hash: string): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_MOBILE_ID,
            payload: { verificationCode, hash }
        };
    }

    loginWithSmartId(verificationCode: string, hash: string): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_SMART_ID,
            payload: { verificationCode, hash }
        };
    }

    loginWithViisp(ticket: string): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_VIISP,
            payload: { ticket }
        };
    }

    loginWithOidcExchange(exchangeId: string): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_OIDC_EXCHANGE,
            payload: { exchangeId }
        };
    }

    cancelChallengePolling(): RidangoReduxAction {
        return {
            type: LoginActions.CANCEL_CHALLENGE_POLLING
        };
    }

    loginAfterAgree(payload: any): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_AFTER_AGREE,
            payload: payload
        };
    }

    loginSuccess(): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_SUCCESS
        };
    }

    loginAuthTokenOnly(credentials: LoginCredentials): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_AUTH_TOKEN_ONLY,
            payload: credentials
        };
    }

    loginSuccessAuthTokenOnly(payload: string): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_SUCCESS_AUTH_TOKEN_ONLY,
            payload: payload
        };
    }

    loginFailed(error: any): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_FAIL,
            payload: error
        };
    }

    forcePasswordReset(payload: boolean): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_FORCE_PASSWORD_RESET,
            payload: payload
        };
    }

    forceAgreement(payload: any): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_FORCE_AGREEMENT,
            payload: payload
        };
    }

    resetForcedAgreement(): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_RESET_FORCED_AGREEMENT
        };
    }

    loginReset(): RidangoReduxAction {
        return {
            type: LoginActions.LOGIN_RESET
        };
    }

    logout(shouldRedirect: boolean = true): RidangoReduxAction {
        return {
            type: LoginActions.LOGOUT,
            payload: { shouldRedirect }
        };
    }

    showTermsModal(): RidangoReduxAction {
        return { type: LoginActions.SHOW_TERMS_MODAL };
    }

    hideTermsModal(): RidangoReduxAction {
        return { type: LoginActions.HIDE_TERMS_MODAL };
    }
}
